import { render, staticRenderFns } from "./BorrarRecordatorioModal.vue?vue&type=template&id=ff9469da"
import script from "./BorrarRecordatorioModal.vue?vue&type=script&lang=js"
export * from "./BorrarRecordatorioModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports